module.exports = __webpack_public_path__ + "7ed4545821a0173e481cd00f23dab394.MP3";